import React from 'react'
import classNames from 'classnames'
import Image from 'next/legacy/image'

import styles from './button.module.scss'

type ButtonTheme =
  | 'gray'
  | 'blue'
  | 'blue-border'
  | 'blue-no-img-stretchy'
  | 'blue-max-width'
  | 'new-green-width'
  | 'new-pink-width'
  | 'white-max-width'
  | 'no-image'
  | 'green'
  | 'red'
  | 'red2'
  | 'auto-width'
  | 'hundred-width'
  | 'red-no-border'
  | 'stretchy'
  | 'red-no-image'
  | 'red-max-width'
  | 'red-wide'
  | 'transparent-light'
  | 'transparent-light2'
  | 'transparent-light3'
  | 'transparent-pink'
  | 'pink-action'
  | 'toast'
  | 'white-small'
  | 'white-small-border'
  | 'transparent'
  | 'pager'
  | 'pager-page'
  | 'pager-page-active'
  | 'lightblue'
  | 'with-images'
  | 'signup-images'
  | 'full-width'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean
  title: string
  theme?: ButtonTheme | ButtonTheme[]
  leftImg?: string
  rightImg?: string
}

const Button = ({
  disabled,
  title,
  onClick,
  theme = 'blue',
  leftImg,
  rightImg,
  type,
}: ButtonProps) => {
  if (typeof theme === 'string') {
    theme = [theme]
  }

  const classes = {
    [styles.container]: true,
    [styles.disabled]: disabled,
  }

  theme.forEach((t) => {
    classes[styles[t]] = typeof t !== 'undefined'
  })

  return (
    <button type={type} className={classNames(classes)} onClick={onClick}>
      <div className={styles.leftImgHolder}>
        {leftImg ? (
          <Image
            src={leftImg}
            width={14}
            height={14}
            className={styles.leftImg}
            loading="lazy"
            alt="left image"
          />
        ) : null}
      </div>
      <span className={styles.title}>{title}</span>
      <div className={styles.rightImgHolder}>
        {rightImg ? (
          <Image
            src={rightImg}
            width={14}
            height={14}
            className={styles.rightImg}
            loading="lazy"
            alt="right image"
          />
        ) : null}
      </div>
    </button>
  )
}

export default Button
